
<div class="col-sm-12 col-xs-12 col-lg-6 paginator-cz-container">
  <nav aria-label="...">
    <ul class="pager pull-right">
      <li>
        Items por página
      </li>
      <li>
        <select class="form-control input-sm" name="cantRows" id="cantRows" (change)="changeItemsPerPage()" #itemsPerPage>
          <option *ngFor="let item of this.options" [value]="item" [selected]="item == selected">
            {{item}}
          </option>
        </select>
      </li>
      <li>{{ modelo.numeroInicial }} - {{ modelo.numeroFinal }} de {{ modelo.cantidad }}</li>
      <li
          [ngClass]="{
            disabled: modelo.actual === 1
          }"
        >
        <span
        class="tooltip-container"
        data-placement="top"
        data-toggle="tooltip"
        title="Anterior"
      >
          <a
            [ngClass]="{
              isDisabled: modelo.actual === 1
            }"
            (click)="nextPage(-1)"
            ><fa-icon [icon]="faChevronLeft"></fa-icon>
          </a>
        </span>
        </li>
      
      <li
        [ngClass]="{
          disabled: modelo.actual === modelo.total
        }"
      >
        <span
          class="tooltip-container"
          data-placement="top"
          data-toggle="tooltip"
          title="Siguiente"
        >
          <a
            [ngClass]="{
              isDisabled: modelo.actual === modelo.total
            }"
            (click)="nextPage(1)"
          >
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </a>
        </span>
      </li>
    </ul>
  </nav>
</div>